import { render, staticRenderFns } from "./danCiLianXi.vue?vue&type=template&id=55344e40&scoped=true&"
import script from "./danCiLianXi.vue?vue&type=script&lang=js&"
export * from "./danCiLianXi.vue?vue&type=script&lang=js&"
import style0 from "./danCiLianXi.vue?vue&type=style&index=0&id=55344e40&prod&lang=scss&"
import style1 from "./danCiLianXi.vue?vue&type=style&index=1&id=55344e40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55344e40",
  null
  
)

export default component.exports